import React, {Fragment} from 'react'
import styled from 'styled-components'
import ProgressIndicator from './progress-indicator'
import { TABLET } from '../../utilities/breakpoints'
import TableColumnLabel from '../ui/table-column-label'
import { getThemeStyle } from '../../utilities/helpers'
import StatementStatBarSm from '../ui/statement-stat-bar-sm'
import ImportanceHearts from '../ui/importance-hearts'
import ThemeBadge from '../ui/theme-badge'
import { isNullOrUndefined } from '../../utilities/helpers'

const StatementProgressCard= ({
  index,
  statement,
  themeIndex = 0,
  showPrevious = false,
  showLabels = false,
  showThemeTitle = false,
  showNumbers = false,
  mode = "list",
  useTranslate
}) => {

  const latestResult = statement.results[0] && !isNullOrUndefined(statement.results[0].result) ? statement.results[0].result : null;
  const latestRate = statement.results[0] && statement.results[0].rate ? statement.results[0].rate : null;
  const previousResult = statement.results[1] && !isNullOrUndefined(statement.results[1].result) ? statement.results[1].result : null;
  const previousRate = statement.results[1] && statement.results[1].rate ? statement.results[1].rate : null;

  return (
    <Wrapper className={`statement-progress-card ${showPrevious ? 'show-previous' : ''} statement-${mode}`}>
      {showLabels && !showPrevious &&
        <LabelsRow className={"labels-row"}>
          <Columns>
            <TitleColumn>
              <TableColumnLabel className="label">{useTranslate('data_vault.label_statement')}</TableColumnLabel>
            </TitleColumn>
            <ProgressColumn>
              <TableColumnLabel className="label">{useTranslate('progress_reports.label_progress')}</TableColumnLabel>
            </ProgressColumn>
            <CurrentStateColumn>
              <TableColumnLabel className="label">{useTranslate('progress_reports.label_latest_current_state')}</TableColumnLabel>
            </CurrentStateColumn>
            <ImportanceColumn>
              <TableColumnLabel className="label">{useTranslate('progress_reports.label_latest_importance')}</TableColumnLabel>
            </ImportanceColumn>
          </Columns>
        </LabelsRow>
      }
      {showLabels && showPrevious &&
        <LabelsRow className={"labels-row"}>
          <Columns>
            <TitleColumn>
              <TableColumnLabel className="label">{useTranslate('data_vault.label_statement')}</TableColumnLabel>
            </TitleColumn>
            <ProgressColumn>
              <TableColumnLabel className="label">{useTranslate('progress_reports.label_progress')}</TableColumnLabel>
            </ProgressColumn>
            <CurrentStateColumn>
              <TableColumnLabel className="label">{useTranslate('progress_reports.label_latest')}</TableColumnLabel>
            </CurrentStateColumn>
            <ImportanceColumn>
              <TableColumnLabel className="label">{useTranslate('progress_reports.label_previous')}</TableColumnLabel>
            </ImportanceColumn>
          </Columns>
        </LabelsRow>
      }
      <StatementCard>
        <Columns>
          <TitleColumn>
            <StatementTitle className={`${showThemeTitle ? "has-theme-title" : ""}`}>
              {(showThemeTitle && statement.catalystTitle.length > 0) &&
                <ThemeBadge themeTitle={statement.catalystTitle} themeIndex={themeIndex} />
              }
              {(showNumbers && !showThemeTitle) &&
                <StatementIndex style={{ backgroundColor: getThemeStyle(themeIndex).bgColor }}>
                  {showNumbers ? index + 1 : ''}
                </StatementIndex>
              }
              <h5>{statement.title}</h5>
            </StatementTitle>
          </TitleColumn>
          <ProgressColumn>
            <TableColumnLabel className="label">{useTranslate('progress_reports.label_progress')}</TableColumnLabel>
            {showPrevious ?
              <ProgressIndicator
                resultProgress={statement.resultProgressSincePrevious}
                ratingProgress={statement.rateProgressSincePrevious}
                size={"md"}
                vertical={true}
              />
              :
              <ProgressIndicator
                resultProgress={statement.resultProgressSincePrevious}
                ratingProgress={statement.rateProgressSincePrevious}
                size={"sm"}
                vertical={false}
              />
            }
          </ProgressColumn>
          <CurrentStateColumn>
            {showPrevious ?
              <Fragment>
                <TableColumnLabel className="label">{useTranslate('progress_reports.label_latest')}</TableColumnLabel>
                <div className="result-container">
                  <StatementStatBarSm result={latestResult} />
                  <span className="result">{latestResult !== null ? `${latestResult.toFixed(0)}%` : "-"}</span>
                </div>
                <div className="result-container" style={{marginTop: "5px"}}>
                  <ImportanceHearts importance={latestRate} />
                  <span className="result">{latestRate !== null ? `${latestRate.toFixed(1)}` : "-"}</span>
                </div>
              </Fragment>
              :
              <Fragment>
                <TableColumnLabel className="label">{useTranslate('progress_reports.label_latest_current_state')}</TableColumnLabel>
                <div className="result-container">
                  <StatementStatBarSm result={latestResult} />
                  <span className="result">{latestResult !== null ? `${latestResult.toFixed(0)}%` : "-"}</span>
                </div>
              </Fragment>
            }
          </CurrentStateColumn>
          <ImportanceColumn>
            {showPrevious ?
              <Fragment>
                <TableColumnLabel className="label">{useTranslate('progress_reports.label_previous')}</TableColumnLabel>
                <div style={{opacity: "0.6"}}>
                  <div className="result-container">
                    <StatementStatBarSm result={previousResult} />
                    <span className="result">{previousResult !== null ? `${previousResult.toFixed(0)}%` : "-"}</span>
                  </div>
                  <div className="result-container" style={{marginTop: "5px"}}>
                    <ImportanceHearts importance={previousRate} />
                    <span className="result">{previousRate !== null ? `${previousRate.toFixed(1)}` : "-"}</span>
                  </div>
                </div>
              </Fragment>
              :
              <Fragment>
                <TableColumnLabel className="label">{useTranslate('progress_reports.label_latest_importance')}</TableColumnLabel>
                <div className="result-container">
                  <ImportanceHearts importance={latestRate} />
                  <span className="result">{latestRate !== null ? `${latestRate.toFixed(1)}` : "-"}</span>
                </div>
              </Fragment>
            }
          </ImportanceColumn>
        </Columns>
      </StatementCard>
    </Wrapper>
  )
}

export default StatementProgressCard;

const Wrapper = styled.div`
 + .statement-progress-card.statement-card {
  margin-top: 1rem;
 }
 
 + .statement-progress-card.statement-list {
  border-top: 1px solid #D7D7D7;
 }
`;

const LabelsRow = styled.div`
  width: 100%;
  display: none;
  
  @media${TABLET} {
    display: block;
    margin-bottom: 10px;
  }
`;

const StatementCard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding-top: 10px;
  padding-bottom: 10px;
  
  .statement-card & {
    border-radius: 10px;
    padding-left: 15px;
    box-shadow: 0 24px 64px rgba(0, 0, 0, 0.04);
  }
  
  .result-container {
    display: flex;
    align-items: center;
    
    .result {
      margin-left: 8px;
      font-size: 14px;
      font-weight: 500;
    }
  }
  
  .statement-stat-bar {
    width: 90px;
  }
  
  .table-column-label {
    margin-bottom: 5px;
  }
  
  @media${TABLET} {
    padding-top: 15px;
    padding-bottom: 15px;
    
    .statement-card & {
      border-radius: 10px;
      padding-left: 25px;
      padding-top: 25px;
      padding-bottom: 25px;
    }
    
    .table-column-label {
      display: none;
    }
  }
`;

const StatementTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  
  &.has-theme-title {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  h5 {
    font-size: 1rem;
    font-weight: 500;
    margin: 0;
  }
  
  @media${TABLET} {
    margin-bottom: 0;
    
    &.has-theme-title {
      padding-right: 20px;
      h5 {
        font-size: 18px;
      }  
    }
  }
`;

const StatementIndex = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 100%;
  display: flex;
  flex: 0 0 20px;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 600;
  font-size: 13px;
  margin-right: 8px;
`;

const Columns = styled.div`
  @media${TABLET} {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 140px repeat(2, 150px);
    grid-column-gap: 10px;
    align-items: center;
    
    .show-previous & {
      grid-template-columns: 1fr 100px repeat(2, 150px);
    }
  }
 `;

const TitleColumn = styled.div`

`;

const ProgressColumn = styled.div`
  margin-bottom: 10px;

  @media${TABLET} {
    margin-bottom: 0;
  }
`;

const CurrentStateColumn = styled.div`
  margin-bottom: 10px;

  @media${TABLET} {
    margin-bottom: 0;
  }
`;

const ImportanceColumn = styled.div`

`;


// WEBPACK FOOTER //
// ./src/components/progress-reports/statement-progress-card.js